import { isEmpty } from 'lodash-es';
import { getFullImageUrl } from 'client/utils/image-helpers';

export const getImageLink = (isMobile, tileEntry) =>
  isMobile && tileEntry.links()[1] ? tileEntry.links()[1] : tileEntry.links()[0];

export const getImageStyle = (tileEntry, isMobile) => {
  if (isEmpty(tileEntry) || isEmpty(tileEntry.links())) {
    return null;
  }
  const imageUrl = getImageLink(isMobile, tileEntry).href;
  return {
    backgroundImage: `url(${getFullImageUrl(imageUrl, 700)})`,
    aspectRatio: tileEntry.metadata('aspectRatio').value() || null,
  };
};
